import { render, staticRenderFns } from "./UploadSoftware.vue?vue&type=template&id=93d000d4&scoped=true"
import script from "./UploadSoftware.vue?vue&type=script&lang=js"
export * from "./UploadSoftware.vue?vue&type=script&lang=js"
import style0 from "./UploadSoftware.vue?vue&type=style&index=0&id=93d000d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d000d4",
  null
  
)

export default component.exports